<template>
  <div class="container"> 
    <div class="entity-header">
      <div>
        <section class="floatright" v-if="personLinked">Persoon zojuist succesvol gelinkt</section>
        <router-link v-if="((uberUser && _userIsHandmade) || loggedInButNotLinked) && !personLinked" to="/info/linking-account/" class="button-icon infoLinkReverse floatright"> <font-awesome-icon icon="link" /> {{ $t('selectUser.thisIsMe') }} <font-awesome-icon class="info" icon="info-circle" /> </router-link>
        <button v-if="uberUser && _userIsHandmade && !personLinked" href="#" class="button-icon square-icon floatright" @click="linkPerson()"><font-awesome-icon icon="link" /> {{ $t('settings.linkToAccount') }}</button>
      </div>

      <div class="entity-title">{{ person.name }}</div>
      <div class="entity-details">{{ $t('persons.federationNumber') }} : {{person.federationNumber}}</div>
      <div class="entity-details">{{ $t('persons.latestRanking') }} : {{person.latestRating}}</div>
    </div>

    <transition name="modal-fade" v-if="_showUserLinking">
      <div class="modal-backdrop">
        <div class="modal">
          <div class="modal-body">
            <slot name="body">
              <SelectUser v-on:cancel="handleLinkPlayerCancel()"
                          v-on:ok="handleLinkPlayerOK()"
                          :personId = person.personId></SelectUser>
            </slot>
          </div>
        </div>
      </div>
    </transition>

    <section v-if="clubs.length > 0">
          <clubs-list :clubs="clubs" :listType="'Table'"></clubs-list>
      <!--
      <table><tbody>
        <tr v-for="club in clubs" :key="club.clubId" :club="club">
          <td><router-link :to="'/clubs/' + club.clubId">{{club.name}}</router-link></td></tr>
      </tbody></table> -->
    </section>
    <section v-if="clubs.length == 0">{{ $t('person.noClub') }} </section>


    <div>
      <tournaments-list v-if="runningTournaments.length != 0" 
        :tournaments="runningTournaments" 
        :listType="'Table'"></tournaments-list>
      
      <section v-if="runningTournaments.length == 0">
        {{ $t('persons.noRunningTournaments') }} 
      </section>

      
      <section v-if="rankingsViaTournament.length == 0">
        {{ $t('persons.noTournamentsPlayed') }} 
      </section>
      <section v-if="rankingsViaTournament.length > 0">
        <table class="fullWidthTable"><tbody>
          <tr class="tableHeader row">
            <td class="xtendCol">{{ $t('person.tournament') }} </td>
            <td>{{ $t('person.rank') }} </td>
            <td>{{ $t('person.score') }} </td>
            <td>{{ $t('person.tpr') }} </td>
          </tr>
          <tr class="row" v-for="tournament in rankingsViaTournament" :key="tournament.rankings[0].rankingId" :tournament="tournament">
            <td><router-link :to="'/tournaments/' + tournament.tournamentId"> {{tournament.name}}</router-link></td>
            <td>{{tournament.rankings[0].rank}}</td>
            <td>{{tournament.rankings[0].points}} {{ $t('person.outOf') }} {{tournament.rankings[0].won + tournament.rankings[0].draw + tournament.rankings[0].lost}}</td>
            <td>{{tournament.rankings[0].tpr}}</td>
          </tr>
        </tbody></table>
      </section>
    </div>


    <div class="section">
      <h2>{{ $t('persons.rating') }} </h2> 
      <section class="chartje">
        <canvas id="myChart" />
      </section>
      <section >
        <table class="fullWidthTable"><tbody>
          <tr class="tableHeader row">
            <td class="xtendCol">{{ $t('person.ratingList') }} </td>
            <td>{{ $t('person.rating') }} </td>
            <td>{{ $t('person.ratingDifference') }} </td>
          </tr>
          <tr class="row" v-for="playerRating in playerRatings" :key="playerRating.personListRatingId" :playerRating="playerRating">
            <td>{{playerRating.ratingList.year}} {{playerRating.ratingList.month}}</td>
            <td>{{playerRating.rating}}</td>
            <td>{{playerRating.difference}}</td>
          </tr>
        </tbody></table>
      </section>
    </div>
  </div>
</template>

<script>
import {RestAPI} from "@aws-amplify/api-rest";
import moment from 'moment';
import SelectUser from '@/components/users/SelectUser';
import Chart from 'chart.js'
import ClubsList from "@/components/clubs/ClubsList";
import TournamentsList from "@/components/tournaments/TournamentsList";

const apiName = 'api';
const myInit = {
  response: false, 
};

export default { 
  name: 'Person',
  components: {SelectUser, ClubsList, TournamentsList},
  props: {
    personId: String
  },
  data: function () {
    return {
      clubs: [],
      person: [],
      personLinked: false,
      playerRatings: [],
      rankingsViaTournament: [],
      runningTournaments: [],
      showUserLinking: false,
    }
  },
  beforeMount() {
    this.loadPerson();
    this.loadClubs();
    this.loadRunningTournaments();
    this.loadTournamentResults();
    this.loadRatings();
  },
  computed: {
    loggedInButNotLinked: function() {
      var libnl = false;
      if (this.$CAUser != null) {
        libnl = !this.$CAUser.linked() && this.$CAUser.loggedIn();
      }
      return libnl;
    },
    _showUserLinking: function() {
      return this.showUserLinking;
    },
    uberUser: function() {
      var uber = false;
      if (this.$CAUser != null) {
        if (this.$CAUser.getChessUser() != null) {
          uber = (process.env.VUE_APP_UBER == this.$CAUser.getChessUser().login);
        }
      }
      return uber; 
    },
    _userIsHandmade: function() {
      return this.person.federationCode == 0;
    }
  },
  methods: {
    createRatingChart(playerRatingsIn) {
      const ctx = document.getElementById('myChart');
      console.log("ctx component: " + JSON.stringify(ctx));
      var config = {
        type: 'line',
        data: {
          labels: [],
          datasets: [{
            label: 'player rating',
            borderColor: '#365c96',
            data: [],
            borderWidth: 1
          }]
        },
        options:{
          scales:{
            xAxes: [{
              id:'xAxis1',
              ticks:{
                  callback:function(label){
                    var month = label.split(";")[0];
                    return month;
                  }
              }
            },
            {
              id:'xAxis2',
              ticks:{
                callback:function(label){
                  var month = label.split(";")[0];
                  var year = label.split(";")[1];
                  if(month === "1"){
                    return year;
                  }else{
                    return "";
                  }
                }
              }
            }],
            yAxes:[{
              ticks:{
                beginAtZero:false
              }
            }]
          }
        }      
      };
      console.log("tussenin: " + JSON.stringify(playerRatingsIn));      
      playerRatingsIn.forEach(function (pr) {
          console.log("pushing: " + JSON.stringify(pr.ratingList.month));      
          config.data.labels.push(pr.ratingList.month + ";" + pr.ratingList.year);
          console.log("pushing: " + JSON.stringify(pr.rating));      
          config.data.datasets[0].data.push(pr.rating);
          console.log("and now?: ");      
        });
      console.log("config: " + JSON.stringify(config));      
      const cahrt = new Chart(ctx, config);
      cahrt;
    },
    
    enrichRatings: function(playerRatingsIn) {
      playerRatingsIn.forEach(function (playerRating) {
        var index = playerRatingsIn.indexOf(playerRating);
        if (index > 0) {
          playerRating.difference = playerRating.rating - playerRatingsIn[index-1].rating;
        } else {
          playerRating.difference = "";
        }
      });

      return playerRatingsIn;
    },

    handleLinkPlayerCancel() {
      this.showUserLinking = false;
    },

    handleLinkPlayerOK() {
      this.personLinked = true;
      this.showUserLinking = false;
    },

    linkPerson() {
      this.showUserLinking = true;
    },

    loadClubs() {
      let that = this
      let path = '/club?personid=' + this.$route.params.personId
      RestAPI
        .get(apiName, path, myInit)
        .then(response => {
          that.clubs = response
        })
        .catch(error => {
          if (error.status !== 404) {
            console.log("ERROR", JSON.stringify(error));
          }
        });
    },

    loadPerson: function() {
      let that = this
      let path = '/person/' + this.$route.params.personId
      console.log("person: " + path)
      RestAPI
        .get(apiName, path, myInit)
        .then(response => {
          that.person = response
          this.$CA_Storage.setVisit("person", this.$route.params.personId, that.person.name);
        })
        .catch(error => {
          if (error.status !== 404) {
            console.log("ERROR", JSON.stringify(error));
          }
        });
    },   

    loadRatings() {
      let that = this
      let path = "/personlistrating?personId=" + this.$route.params.personId;
      RestAPI
        .get(apiName, path, myInit)
        .then(response => {
          that.playerRatings = that.enrichRatings(response);
          that.createRatingChart(that.playerRatings);
        })
        .catch(error => {
          if (error.status !== 404) {
            console.log("ERROR", JSON.stringify(error));
          }
        });
    },

    loadRunningTournaments() {
      let that = this
      let path = '/tournament?personId=' + this.$route.params.personId;
      RestAPI
        .get(apiName, path, myInit)
        .then(response => {
          that.runningTournaments = response;
        })
        .catch(error => {
          if (error.status !== 404) {
            console.log("ERROR", JSON.stringify(error));
          }
        });
    },

    loadTournamentResults: function() {
      let that = this
      let path = '/person/' + this.$route.params.personId + "/rankings"
      console.log("personrankings: " + path)
      RestAPI
        .get(apiName, path, myInit)
        .then(response => {
          console.log("rankings loaded." + JSON.stringify(response));
          that.rankingsViaTournament = response;
        })
        .catch(error => {
          if (error.status !== 404) {
            console.log("ERROR", JSON.stringify(error));
          }
        });
    },

    showDate: function(sDate) {
      return moment(sDate).format("DD MMM yyyy");
    }, 

    determineTournamentManagement() {
      
      console.log("this.tournament.managers.length: " + this.tournament.managers.length);
      console.log("managers: " + JSON.stringify(this.tournament.managers));
      if (this.tournament.managers.length > 0) {
        console.log("this.$CAUser.getPersonId(): " + this.$CAUser.getPersonId());
        var persons = this.tournament.managers.filter((item) => {
              return (item.personId == this.$CAUser.getPersonId());
          });
        console.log("person is manager: " + JSON.stringify(persons));
        this.thisUserIsTournamentManager = (persons.length == 1);      
      } 
    },

    userIsTournamentManager: function() {
      // Function to determine if the current user is the manager of a tournament the shown player is part of.
      return true;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

td {
  padding-left: 8px;
  padding: 10px 10px;
  border-bottom: 1px solid #3a3a3a;
}

tr:last-child td {
    border-bottom: none;
}

header {
    border-radius: 2px 2px 0px 0px;
    width: 100%;
}

.tableHeader td {
    color: white;
  }


.lastCol {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: right;
  width: 50px;
}

.info {
  margin-left: 6px;
}

.details {
  border-radius: 0px 0px 2px 2px;
}

.xtendCol {
width: auto;
}

.fullWidthTable {
  background-color: #2a2a2a;
  border-radius: 5px;
  overflow-x: auto;
  margin-top: 20px;
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  box-sizing: border-box;
}

/* mobile */
@media screen and (max-width: 600px) {

  .details {
    padding: 2vw;
    border-radius: 0px 0px 2px 2px;
  }

  .personContainer {
    width: 98vw;
  }

  .fullWidthTable {
    width: 98vw;
    max-width: 98vw;
    overflow-x: auto;
  }

}

/* ipad */
@media screen and (min-width: 601px) and (max-width: 1280px) {

  .details {
    padding: 1vw;
  }
.personDetails {
  width: 50vw;
}
  .personContainer {
    width: 70vw;
  }

  .fullWidthTable {
    width: 100%;
    max-width: 100%;
    overflow-x: auto;
  }

}

/* laptop */
@media screen and (min-width: 1281px) {

  .details {
    padding: 1vw;
  }

  .personContainer {
    width: 50vw;
  }

.personDetails {
  width: 50vw;
}

}

</style>
